import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { CartItem } from '../components/restaurant/CartItem';
import { useCart } from '../lib/cart';
import { formatCurrency } from '../lib/utils';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';
import { useKitchenPause } from '../lib/kitchen-pause-context';
import { ShoppingBag, ArrowLeft, Store } from 'lucide-react';
export function CartPage() {
  const navigate = useNavigate();
  const {
    cart,
    updateQuantity,
    removeItem,
    getTotal,
    clearCart
  } = useCart();
  const {
    isKitchenPaused,
    monitorRestaurant
  } = useKitchenPause();
  // Register restaurant with central kitchen pause monitor
  useEffect(() => {
    if (cart.restaurantId) {
      console.log('[NOIZA][CartPage] Registering restaurant:', cart.restaurantId);
      monitorRestaurant(cart.restaurantId);
    }
  }, [cart.restaurantId, monitorRestaurant]);
  const subtotal = getTotal();
  // In a real app, delivery fee would be calculated based on distance/settings
  const deliveryFeeEstimate = cart.items.length > 0 ? 1500 : 0;
  const total = subtotal + deliveryFeeEstimate;
  if (cart.items.length === 0) {
    return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-2012">
        <MarketplaceHeader data-id="element-2013" />
        <main className="flex-1 flex items-center justify-center py-12" data-id="element-2014">
          <EmptyState icon={ShoppingBag} title="Tu carrito está vacío" description="Aún no has agregado ningún producto a tu pedido. ¡Explora los restaurantes y encuentra algo delicioso!" actionLabel="Explorar restaurantes" onAction={() => navigate('/restaurants')} data-id="element-2015" />
        </main>
        <Footer data-id="element-2016" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col bg-brand-offwhite" data-id="element-2017">
      <MarketplaceHeader data-id="element-2018" />

      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-8" data-id="element-2019">
        <div className="flex items-center justify-between mb-8" data-id="element-2020">
          <div className="flex items-center gap-4" data-id="element-2021">
            <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-gray-400 hover:text-gray-900 rounded-full hover:bg-gray-50 transition-colors" data-id="element-2022">
              <ArrowLeft className="w-6 h-6" data-id="element-2023" />
            </button>
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-2024">Tu Pedido</h1>
          </div>
          <button onClick={clearCart} className="text-sm font-medium text-red-500 hover:text-red-600 transition-colors" data-id="element-2025">
            Vaciar
          </button>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden mb-8" data-id="element-2026">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex items-center gap-3" data-id="element-2027">
            <Store className="w-5 h-5 text-gray-500" data-id="element-2028" />
            <span className="font-semibold text-gray-900" data-id="element-2029">
              {cart.restaurantName}
            </span>
          </div>

          <div className="px-6 py-2" data-id="element-2030">
            {cart.items.map(item => <CartItem key={item.id} item={item} onUpdateQuantity={updateQuantity} onRemove={removeItem} data-id="element-2031" />)}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 mb-8" data-id="element-2032">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-2033">Resumen</h3>

          <div className="space-y-3 text-sm text-gray-600 mb-6" data-id="element-2034">
            <div className="flex justify-between" data-id="element-2035">
              <span data-id="element-2036">Subtotal</span>
              <span className="font-medium text-gray-900" data-id="element-2037">
                {formatCurrency(subtotal)}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-2038">
              <span data-id="element-2039">Costo de envío (Estimado)</span>
              <span className="font-medium text-gray-900" data-id="element-2040">
                {formatCurrency(deliveryFeeEstimate)}
              </span>
            </div>
            <div className="pt-3 border-t border-gray-100 flex justify-between text-lg font-bold text-gray-900" data-id="element-2041">
              <span data-id="element-2042">Total Estimado</span>
              <span data-id="element-2043">{formatCurrency(total)}</span>
            </div>
          </div>

          {isKitchenPaused && <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 mb-4 text-center" data-id="element-2044">
              <p className="text-red-700 text-sm font-medium" data-id="element-2045">
                🔴 Cocina pausada — no se pueden enviar pedidos ahora
              </p>
            </div>}
          <Button size="lg" fullWidth className="text-lg shadow-xl" onClick={() => navigate('/checkout')} disabled={isKitchenPaused} data-id="element-2046">
            {isKitchenPaused ? 'Cocina Pausada' : 'Continuar al Pago'}
          </Button>

          <p className="text-center text-xs text-gray-500 mt-4" data-id="element-2047">
            El costo de envío final se calculará en el siguiente paso.
          </p>
        </div>
      </main>

      <Footer data-id="element-2048" />
    </div>;
}